<template>
  <mh-category-modal
    :id="id"
    ref="modal"
    :title="title"
    :category-id="categoryId"
    :type="type"
    @data:loaded="injectItemData"
  />
</template>

<script>
export default {
    name: 'CustomerServiceModal',
    props: {
        id: {
            type: String,
            required: true
        },
        categoryId: {
            type: Number,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        type: {
            type: String,
            default: 'description1'
        }
    },
    methods: {
        injectItemData ({ description }) {
            let variationId = null
            const data = document.location.pathname.match(/_([0-9]+)_([0-9]+)$/)
            if (data && data[2]) {
                variationId = data[2]
            } else {
                const itemId = this.$store.state.items?.mainItemId
                variationId = this.$store.state.items[itemId]?.variation.documents[0].id
            }
            if (variationId) {
                let newDescription = description.replace('##variationId##', variationId)
                newDescription = newDescription.replace('d-none variation-id-container', 'd-flex')
                this.$refs.modal.setDescription(newDescription)
            }
        }
    }
}
</script>

<style scoped>

</style>
